module.exports = __webpack_public_path__ + "img/performa-telethon.412c625d.png";